var map = {
	"./CVIcon.png": [
		3575,
		3575
	],
	"./EmailIcon.png": [
		2324,
		2324
	],
	"./GitHubIcon.png": [
		421,
		421
	],
	"./InstagramIcon.png": [
		560,
		560
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2533;
module.exports = webpackAsyncContext;